export default __webpack_public_path__ + "static/media/java.d004bc17.svg";